export default "__VITE_ASSET__InM82IDEXDTBlApwxnDLXg__"